import { DuoConfirmModal } from "./DuoConfirmModal";

export type ExitConfirmDuoProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ExitConfirmDuo({
  open,
  onCancel,
  onConfirm,
}: ExitConfirmDuoProps) {
  return (
    <DuoConfirmModal
      open={open}
      title="Verlaat simulatie?"
      body="Feedback wordt zichtbaar."
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
